export default {"src":"/_next/static/media/gdpr.5fb5329f.svg","height":81,"width":80,"blurWidth":0,"blurHeight":0};